import { render, staticRenderFns } from "./edit-office-bank.vue?vue&type=template&id=f7fce0c4&"
import script from "./edit-office-bank.vue?vue&type=script&lang=js&"
export * from "./edit-office-bank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports